<div class="pull-right">
  <button
    class="closebtn"
    mat-button
    color="accent"
    (click)="cancelAction()"
    id="bucket-items-rename-dialog-btn-close"
    >
    <span class="icon-ic-close popup_close"></span>
  </button>
</div>
<div class="dialog-container">
  <h5>Rename</h5>

  <div class="dialog-content input-min-spacing">
    <mat-form-field id="folderNameField" class="w-100">
      <mat-label>Folder Name</mat-label>
      <input
        matInput
        placeholder="Enter a folder name"
        [formControl]="folderName"
        id="bucket-items-rename-dialog-fld-name"
        />
        @if (folderName.errors?.required) {
          <mat-error>
            Folder name is a mandatory field.
          </mat-error>
        }
        @if (folderName.errors?.maxlength) {
          <mat-error>
            Folder name cannot have more than 150 characters
          </mat-error>
        }
        @if (folderName.errors?.pattern) {
          <mat-error>
            Folder name must not contain special characters: / : * ? \\ \" < > |
          </mat-error>
        }
        @if (folderName.errors?.inValidStudyPackageFolderName) {
          <mat-error>
            Please enter valid Study code
          </mat-error>
        }
        @if (folderName.errors?.inValidFacilityPackageFolderName) {
          <mat-error>
            Folder name cannot have Study Code structure
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div>
      <button
        mat-button
        color="primary"
        class="confirm-btn primary-hover"
        mat-raised-button
        (click)="renameFolder()"
        id="bucket-items-rename-dialog-btn-confirm"
        >
        Rename
      </button>
      <button
        mat-button
        (click)="dismiss()"
        color="primary"
        class="mat-button secondary-hover w-120"
        id="bucket-items-rename-dialog-btn-cancel"
        >
        Cancel
      </button>
    </div>
  </div>
